import { DemandeValidationPjStatutConsultantEnum } from '@graphql/generated';
import { DemandeValidationPjStatutConsultant } from '@lib/models/demande-validation-pj/types/demande-validation-pj-statut.type';

export class DemandeValidationPjStatutConsultantMapper {
  public static toGraphQl(
    input: DemandeValidationPjStatutConsultant | null
  ): DemandeValidationPjStatutConsultantEnum | undefined {
    const mapping: Record<
      DemandeValidationPjStatutConsultant,
      DemandeValidationPjStatutConsultantEnum
    > = {
      annule: DemandeValidationPjStatutConsultantEnum.Annule,
      expire: DemandeValidationPjStatutConsultantEnum.Expire,
      nc_traitee: DemandeValidationPjStatutConsultantEnum.NcTraitee,
      nc_a_traiter: DemandeValidationPjStatutConsultantEnum.NcATraiter,
      a_completer: DemandeValidationPjStatutConsultantEnum.ACompleter,
      brouillon: DemandeValidationPjStatutConsultantEnum.Brouillon,
      validation_en_attente: DemandeValidationPjStatutConsultantEnum.ValidationEnAttente,
      valide: DemandeValidationPjStatutConsultantEnum.Valide,
      refuse: DemandeValidationPjStatutConsultantEnum.Refuse,
      en_signature: DemandeValidationPjStatutConsultantEnum.EnSignature,
    };
    return input ? mapping[input] : undefined;
  }

  public static fromGraphQl(
    input: DemandeValidationPjStatutConsultantEnum | null | undefined
  ): DemandeValidationPjStatutConsultant | undefined {
    const mapping: Record<
      DemandeValidationPjStatutConsultantEnum,
      DemandeValidationPjStatutConsultant
    > = {
      ANNULE: 'annule',
      EXPIRE: 'expire',
      NC_A_TRAITER: 'nc_a_traiter',
      NC_TRAITEE: 'nc_traitee',
      A_COMPLETER: 'a_completer',
      VALIDE: 'valide',
      BROUILLON: 'brouillon',
      VALIDATION_EN_ATTENTE: 'validation_en_attente',
      REFUSE: 'refuse',
      EN_SIGNATURE: 'en_signature',
    };
    return input ? mapping[input] : undefined;
  }
}
